import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  List,
  ListItem,
  ListItemText,
  IconButton,
  Menu,
  MenuItem,
  Container,
  Paper,
  Typography,
  Box,
  Divider,
  Button,
  ListItemIcon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  FormControl,
  InputLabel,
  Select,
  SpeedDial,
  SpeedDialIcon,
  SpeedDialAction,
  Breadcrumbs,
  Link,
  useTheme,
  Snackbar,
  Alert,
} from "@mui/material";
import { teal } from "@mui/material/colors";

// Iconos
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ArticleIcon from "@mui/icons-material/Article";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import QuizIcon from "@mui/icons-material/Quiz";
import SchoolIcon from "@mui/icons-material/School";
import LibraryAddIcon from "@mui/icons-material/LibraryAdd";
import HomeIcon from "@mui/icons-material/Home";
import GroupsOutlined from "@mui/icons-material/GroupsOutlined";
import axios from "axios";
//Componentes Importados
import Restricted from "components/Restricted";

const initialPools = [
  {
    id: 1,
    name: "Conocimientos sobre Nutrición Infantil",
    category: "Nutrición",
    questions: [
      {
        id: 101,
        question: "¿Cuál es la principal fuente de vitamina C?",
        answers: [
          { text: "Manzanas", isCorrect: false },
          { text: "Naranjas", isCorrect: true },
          { text: "Plátanos", isCorrect: false },
          { text: "Uvas", isCorrect: false },
        ],
        difficulty: "Basico",
      },
      {
        id: 102,
        question:
          "La lactancia materna exclusiva se recomienda hasta los 6 meses.",
        answers: [
          { text: "Verdadero", isCorrect: true },
          { text: "Falso", isCorrect: false },
        ],
        difficulty: "Basico",
      },
    ],
  },
  {
    id: 2,
    name: "Protocolos de Atención Primaria",
    category: "Salud",
    questions: [
      {
        id: 201,
        question: "¿Cuál de estos es un síntoma de deshidratación severa?",
        answers: [
          { text: "Piel elástica", isCorrect: false },
          { text: "Ojos hundidos", isCorrect: true },
          { text: "Mucha energía", isCorrect: false },
          { text: "Orina clara", isCorrect: false },
        ],
        difficulty: "Intermedio",
      },
    ],
  },
  {
    id: 3,
    name: "Prácticas de Higiene y Saneamiento",
    category: "WASH",
    questions: [],
  },
  {
    id: 4,
    name: "Técnicas Avanzadas de Primeros Auxilios",
    category: "Salud",
    questions: [
      {
        id: 401,
        question:
          "¿Cuál es el acrónimo para evaluar a una persona inconsciente?",
        answers: [
          { text: "RICE", isCorrect: false },
          { text: "ABC (Airway, Breathing, Circulation)", isCorrect: true },
          { text: "FAST (Face, Arms, Speech, Time)", isCorrect: false },
          { text: "STOP", isCorrect: false },
        ],
        difficulty: "Experto",
      },
    ],
  },
];

const capitalizeWords = (str) => {
  if (!str) return "";
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

const PoolsLista = () => {
const [pools, setPools] = useState([]);
  const [loading, setLoading] = useState(true);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPool, setSelectedPool] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [poolName, setPoolName] = useState("");
  const [poolCategory, setPoolCategory] = useState("");
  const [editingPool, setEditingPool] = useState(null);
  const [openSpeedDial, setOpenSpeedDial] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const navigate = useNavigate();
  const nav = useNavigate();
  const openMenu = Boolean(anchorEl);
  const theme = useTheme();

  const [items, setItems] = React.useState([]);
  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("token"));
    if (items) {
      setItems(items);
    }
  }, []);

  useEffect(() => {
    const fetchPools = async () => {
      try {
        const { data } = await axios.get("/pools");
        // Backend devuelve: id_pool, nombre_pool, id_categoria, nombre_categoria
        console.log(data,"mappa")
       const mapped = data.map((p) => ({
  id: p.id_pool,
  name: p.nombre_pool,
  category: p.nombre_categoria,
  id_categoria: p.id_categoria,
  totalQuestions: Number(p.total_preguntas) || 0,
}));

setPools(mapped);
      } catch (error) {
        console.error("Error al cargar pools desde el servidor:", error);
        showSnackbar("Error cargando pools desde el servidor.", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchPools();
  }, []);

  const rol = items.rol;

  function handleClickBreadCrumbs(event) {
    event.preventDefault();
  }

  const handleLinkHome = (event, message) => {
    if (message === "home") nav("/inicio");
  };
  const handleLinkGestion = (event, message) => {
    if (message === "gestion") nav("/gestionhumana");
  };

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setPoolName("");
    setPoolCategory("");
    setEditingPool(null);
  };
  const handleOpenCreateModal = () => {
    setEditingPool(null);
    setPoolName("");
    setPoolCategory("");
    setOpenModal(true);
  };
  const handleOpenEditModal = () => {
    if (selectedPool) {
      setEditingPool(selectedPool);
    setPoolName(selectedPool.name);
    // aquí poolCategory debe ser el id_categoria, no el nombre
    setPoolCategory(selectedPool.id_categoria);
    setOpenModal(true);
    }
    handleMenuClose();
  };

  const handleSavePool = async () => {
  const trimmedName = poolName.trim();
  if (!trimmedName || !poolCategory) {
    showSnackbar("Por favor, completa todos los campos.", "error");
    return;
  }

  // Evitar duplicados por nombre (opcional, puedes mejorar esto usando backend)
  const isDuplicate = pools.some(
    (p) =>
      p.id !== editingPool?.id &&
      p.name.toLowerCase() === trimmedName.toLowerCase()
  );
  if (isDuplicate) {
    showSnackbar("Ya existe un pool con este nombre.", "error");
    return;
  }

  try {

    if (editingPool) {
      // EDITAR
      
      const payload = {
        nombre_pool: trimmedName,
        id_categoria: Number(poolCategory),
      };
      const { data } = await axios.put(`/pools/${editingPool.id}`, payload);
      // data: id_pool, nombre_pool, id_categoria, nombre_categoria
      setPools((prev) =>
        prev.map((pool) =>
          pool.id === editingPool.id
            ? {
                ...pool,
                id: data.id_pool,
                name: data.nombre_pool,
                category: data.nombre_categoria,
                id_categoria: data.id_categoria,
              }
            : pool
        )
      );
      showSnackbar("Pool editado con éxito.", "success");
    } else {
      // CREAR
      
      const payload = {
        nombre_pool: trimmedName,
        id_categoria: Number(poolCategory),
      };
      console.log(payload,"datos crear")
      const { data } = await axios.post("/pools", payload);
      setPools((prev) => [
        ...prev,
        {
          id: data.id_pool,
          name: data.nombre_pool,
          category: data.nombre_categoria,
          id_categoria: data.id_categoria,
          questions: [],
        },
      ]);
      showSnackbar("Pool creado con éxito.", "success");
    }

    handleCloseModal();
  } catch (error) {
    console.error("Error guardando pool:", error);
    showSnackbar("Error guardando el pool en el servidor.", "error");
  }
};


  const handleMenuOpen = (event, pool) => {
    setAnchorEl(event.currentTarget);
    setSelectedPool(pool);
  };
  const handleMenuClose = () => setAnchorEl(null);

  const handleDetails = () => {
    if (selectedPool) {
      navigate("/questionLista", { state: { pool: selectedPool } });
    }
    handleMenuClose();
  };

  const handleDelete = async () => {
  if (!selectedPool) return;

  try {
    await axios.delete(`/pools/${selectedPool.id}`);
    setPools((currentPools) =>
      currentPools.filter((pool) => pool.id !== selectedPool.id)
    );
    showSnackbar("Pool eliminado con éxito.", "success");
  } catch (error) {
    console.error("Error eliminando pool:", error);
    showSnackbar("Error eliminando el pool en el servidor.", "error");
  }

  handleMenuClose();
};


  const actions = [
    {
      icon: <SchoolIcon />,
      name: "Crear Examen",
      onClick: () => {
        navigate("/crearTest", { state: { pools: pools } });
        setOpenSpeedDial(false);
      },
    },
    {
      icon: <LibraryAddIcon />,
      name: "Nuevo Pool",
      onClick: () => {
        handleOpenCreateModal();
        setOpenSpeedDial(false);
      },
    },
  ];

  return (
    <div className="exclude">
      {rol === "1" || rol === "2" || rol === "7" ? (
        <>
          <Box m="1.5rem 2.5rem">
            <Box
              role="presentation"
              onClick={handleClickBreadCrumbs}
              sx={{ mb: 3 }}
            >
              <Breadcrumbs aria-label="breadcrumb">
                <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="inherit"
                  href="/inicio"
                  onClick={(event) => handleLinkHome(event, "home")}
                >
                  <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                  Inicio
                </Link>
                <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="inherit"
                  href="/gestionhumana"
                  onClick={(event) => handleLinkGestion(event, "gestion")}
                >
                  <GroupsOutlined sx={{ mr: 0.5 }} fontSize="inherit" />
                  Gestión Humana
                </Link>
                <Typography
                  sx={{ display: "flex", alignItems: "center" }}
                  color="text.primary"
                >
                  <QuizIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                  Gestion de Pools
                </Typography>
              </Breadcrumbs>
            </Box>
            <Container maxWidth="xl" sx={{ my: 4, px: "0 !important" }}>
              <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                sx={{ mt: 8 }}
              >
                <Alert
                  onClose={handleSnackbarClose}
                  severity={snackbarSeverity}
                  variant="filled"
                  sx={{ width: "100%" }}
                >
                  {snackbarMessage}
                </Alert>
              </Snackbar>
              <Box sx={{ my: 4, pb: { xs: 10, sm: 0 } }}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={3}
                >
                  <Typography variant="h4" component="h1" gutterBottom>
                    <b>Gestión de Pools de Preguntas</b>
                  </Typography>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <Button
                      variant="contained"
                      startIcon={<SchoolIcon />}
                      onClick={() =>
                        navigate("/crearTest", { state: { pools: pools } })
                      }
                      sx={{
                        display: { xs: "none", sm: "flex" },
                        bgcolor: "secondary.main",
                        "&:hover": { bgcolor: "secondary.dark" },
                      }}
                    >
                      Crear Examen
                    </Button>
                    <Button
                      variant="contained"
                      startIcon={<LibraryAddIcon />}
                      onClick={handleOpenCreateModal}
                      sx={{
                        display: { xs: "none", sm: "flex" },
                        bgcolor: teal[500],
                        "&:hover": { bgcolor: teal[700] },
                      }}
                    >
                      Nuevo Pool
                    </Button>
                  </Box>
                </Box>

                <Paper
                  elevation={3}
                  sx={{
                    borderRadius: 4,
                    bgcolor: theme.palette.background.alt,
                  }}
                >
                  <List sx={{ p: 0 }}>
                    {pools.map((pool, index) => (
                      <React.Fragment key={pool.id}>
                        <ListItem
                          secondaryAction={
                            <IconButton
                              edge="end"
                              aria-label="opciones"
                              onClick={(e) => handleMenuOpen(e, pool)}
                            >
                              <MoreVertIcon />
                            </IconButton>
                          }
                          sx={{ py: 2 }}
                        >
                          <ListItemIcon>
                            <QuizIcon
                              color="action"
                              sx={{ fontSize: { xs: "2rem", sm: "2.5rem" } }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            primary={pool.name}
                            secondary={`Categoría: ${pool.category} - ${pool.totalQuestions} preguntas`}
                            primaryTypographyProps={{
                              fontWeight: "bold",
                              sx: { fontSize: { xs: "1rem", sm: "1.03rem" } },
                            }}
                            secondaryTypographyProps={{
                              sx: {
                                fontSize: { xs: "0.875rem", sm: "0.95rem" },
                              },
                            }}
                          />
                        </ListItem>
                        {index < pools.length - 1 && (
                          <Divider variant="inset" component="li" />
                        )}
                      </React.Fragment>
                    ))}
                  </List>
                </Paper>

                <Box display="flex" justifyContent="flex-end" mt={2}>
                  <Typography
                    variant="h6"
                    component="p"
                    sx={{ color: "text.secondary", fontWeight: "bold" }}
                  >
                    Total de Pools: {pools.length}
                  </Typography>
                </Box>

                <Menu
                  id="pool-menu"
                  anchorEl={anchorEl}
                  open={openMenu}
                  onClose={handleMenuClose}
                >
                  <MenuItem onClick={handleDetails}>
                    <ListItemIcon>
                      <ArticleIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Detalles</ListItemText>
                  </MenuItem>
                  <MenuItem onClick={handleOpenEditModal}>
                    <ListItemIcon>
                      <EditIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Editar</ListItemText>
                  </MenuItem>
                  <Divider />
                  <MenuItem onClick={handleDelete} sx={{ color: "error.main" }}>
                    <ListItemIcon>
                      <DeleteIcon fontSize="small" color="error" />
                    </ListItemIcon>
                    <ListItemText>Eliminar</ListItemText>
                  </MenuItem>
                </Menu>
              </Box>

              <SpeedDial
                ariaLabel="SpeedDial para acciones"
                sx={{
                  display: { xs: "block", sm: "none" },
                  position: "fixed",
                  bottom: 16,
                  right: 16,
                }}
                icon={<SpeedDialIcon />}
                onClose={() => setOpenSpeedDial(false)}
                onOpen={() => setOpenSpeedDial(true)}
                open={openSpeedDial}
                direction="up"
                FabProps={{
                  sx: {
                    bgcolor: teal[500],
                    "&:hover": {
                      bgcolor: teal[700],
                    },
                    width: 72,
                    height: 72,
                  },
                }}
              >
                {actions.map((action) => (
                  <SpeedDialAction
                    key={action.name}
                    icon={action.icon}
                    tooltipTitle={action.name}
                    onClick={action.onClick}
                  />
                ))}
              </SpeedDial>

              <Dialog
                open={openModal}
                onClose={handleCloseModal}
                PaperProps={{
                  sx: {
                    borderRadius: 4,
                    bgcolor: theme.palette.background.alt,
                  },
                }}
              >
                <DialogTitle
                  sx={{
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: { xs: "1.15rem", sm: "1.5rem" },
                  }}
                >
                  {editingPool
                    ? "Editar Pool de Preguntas"
                    : "Crear Nuevo Pool de Preguntas"}
                </DialogTitle>
                <Divider sx={{ width: "95%", mx: "auto" }} />
                <DialogContent sx={{ pt: "20px !important" }}>
                  <DialogContentText sx={{ mb: 2 }}>
                    {editingPool
                      ? "Modifica la información del pool."
                      : "Por favor, completa la información del nuevo pool."}
                  </DialogContentText>
                  <TextField
                    autoFocus
                    margin="dense"
                    label="Nombre del Pool"
                    type="text"
                    fullWidth
                    variant="outlined"
                    value={poolName}
                    onChange={(e) =>
                      setPoolName(capitalizeWords(e.target.value))
                    }
                  />
                  <FormControl
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    sx={{ mt: 2 }}
                  >
                    <InputLabel id="category-select-label">
                      Categoría
                    </InputLabel>
                    <Select
                      labelId="category-select-label"
                      value={poolCategory}
                      label="Categoría"
                      onChange={(e) => setPoolCategory(e.target.value)}
                    >
                      <MenuItem value={1}>Salud</MenuItem>
                      <MenuItem value={2}>Nutrición</MenuItem>
                      <MenuItem value={3}>WASH</MenuItem>
                    </Select>
                  </FormControl>
                </DialogContent>
                <Divider sx={{ width: "95%", mx: "auto" }} />
                <DialogActions sx={{ p: "16px 24px" }}>
                  <Button
                    onClick={handleCloseModal}
                    variant="contained"
                    color="error"
                    size="large"
                    sx={{ mr: 2 }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    onClick={handleSavePool}
                    variant="contained"
                    size="large"
                    disabled={!poolName.trim() || !poolCategory}
                    sx={{
                      bgcolor: teal[500],
                      "&:hover": { bgcolor: teal[700] },
                    }}
                  >
                    Guardar
                  </Button>
                </DialogActions>
              </Dialog>
            </Container>
          </Box>
        </>
      ) : (
        <Box m="1.5rem 2.5rem">
          <Restricted />
        </Box>
      )}
    </div>
  );
};

export default PoolsLista;
